import { useEffect, useRef, useState } from 'react'
import type { Track } from 'livekit-client'
import { LIMIT_LABELS, formatBitrate, getVideoStatsReport, readVideoStats, type StatsCursor, type VideoStats } from '@/lib/videoStats'
import styles from './StreamStats.module.css'

/** Цифры трансляции раз в секунду: что реально отдаётся или принимается, а не что выбрали в окне качества. */
export function StreamStats({ track, own }: { track: Track; own: boolean }) {
  const [stats, setStats] = useState<VideoStats | null>(null)
  const cursor = useRef<StatsCursor | null>(null)

  useEffect(() => {
    cursor.current = null
    let stop = false
    const tick = async () => {
      const report = await getVideoStatsReport(track).catch(() => undefined)
      if (stop || !report) return
      const next = readVideoStats(report, cursor.current)
      if (!next) return
      cursor.current = next.cursor
      setStats(next.stats)
    }
    void tick()
    const timer = setInterval(() => void tick(), 1000)
    return () => {
      stop = true
      clearInterval(timer)
    }
  }, [track])

  if (!stats) return <div className={styles.stats}>считаем…</div>
  const limit = stats.limit && stats.limit !== 'none' ? LIMIT_LABELS[stats.limit] : ''
  return (
    <div className={styles.stats}>
      <span>{stats.width}×{stats.height}</span>
      <span data-tooltip={stats.sourceFps !== undefined ? `захват отдаёт ${stats.sourceFps} к/с` : undefined}>
        {stats.fps} к/с
        {/* если захват отдаёт меньше, чем ушло в кодировщик, потолок не у нас */}
        {stats.sourceFps !== undefined && Math.abs(stats.sourceFps - stats.fps) > 2 ? ` из ${stats.sourceFps}` : ''}
      </span>
      <span>{formatBitrate(stats.kbps)}</span>
      {stats.codec ? <span>{stats.codec}</span> : null}
      {own && stats.encodeMs !== undefined ? <span>{stats.encodeMs.toLocaleString('ru-RU')} мс/кадр</span> : null}
      {own && stats.encoder ? <span className={styles.hint}>кодировщик: {stats.encoder}</span> : null}
      {limit ? <span className={styles.limit}>{limit}</span> : null}
      {own && !limit && stats.sourceFps !== undefined && stats.sourceFps < 55 && stats.fps >= stats.sourceFps - 2 ? (
        <span className={styles.hint}>больше не отдаёт система</span>
      ) : null}
      {!own && !limit ? <span className={styles.hint}>как отдаёт показывающий</span> : null}
    </div>
  )
}
